<template>
    <PopupRouterView :showLeftIcon="true" label="Posting Supply For Production Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="postingsupplyforproduction"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="postingSupplyForProductionInput">


        <b-card header="Posting Supply For Production" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="pickingSupplyForProductions" optionsLabel="workOrderSupply" optionsKey="id" label-cols-lg="12" label="Picking Supply For Production" id="fieldset-picking-supply-for-production" size="sm" :model.sync="model.pickingSupplyForProductionId"   :selected="model.pickingSupplyForProduction != null ? model.pickingSupplyForProduction.workOrderSupply : ''" @input="getPickingSupplyForProductions" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPickingSupplyForProduction" />
						<app-input-combobox-autocomplete :options="workOrderSupplys" optionsLabel="workOrderSupplyDate" optionsKey="id" label-cols-lg="12" label="Work Order Supply Id" id="fieldset-work-order-supply" size="sm" :model.sync="model.workOrderSupplyId"   :selected="model.workOrderSupply != null ? model.workOrderSupply.workOrderSupplyDate : ''" @input="getWorkOrderSupplys" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderSupply" />
						<app-input-combobox-autocomplete :options="workOrderProcesss" optionsLabel="workOrderProcessNumber" optionsKey="id" label-cols-lg="12" label="Work Order Process Id" id="fieldset-work-order-process" size="sm" :model.sync="model.workOrderProcessId"   :selected="model.workOrderProcess != null ? model.workOrderProcess.workOrderProcessNumber : ''" @input="getWorkOrderProcesss" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderProcess" />
						<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Line" id="fieldset-line" size="sm" :model.sync="model.lineId"   :selected="model.line != null ? model.line.code : ''" @input="getLines" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedLine" />
						<app-input-datepicker  id="fieldset-work-order-supply-date" label-cols-lg="12"  label="Work Order Supply Date" size="sm" :model.sync="model.workOrderSupplyDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" />
						<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "Posting Supply Detail For Production"
			:bordered="true" :items="postingSupplyDetailForProductions" 
			:fields="fieldsPostingSupplyDetailForProduction" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByPostingSupplyDetailForProduction" 
			:sort-desc.sync="sortDescPostingSupplyDetailForProduction" small responsive	
			@editButtonMethod="editRowDataPostingSupplyDetailForProduction"	
			@deleteButtonMethod="deleteRowDataPostingSupplyDetailForProduction"	
			@showPopupAddMethod="addDataPostingSupplyDetailForProduction()"	
			@showPopupUploadMethod="showPopupUploadPostingSupplyDetailForProduction()"
			@downloadMethod="downloadPostingSupplyDetailForProduction()"
			@addFromClipboardMethod="addFromClipboardPostingSupplyDetailForProduction()"
			@replaceFromClipboardMethod="replaceFromClipboardPostingSupplyDetailForProduction()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadPostingSupplyDetailForProduction"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPostingSupplyDetailForProductionFilter = !isShowPostingSupplyDetailForProductionFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowPostingSupplyDetailForProductionFilter">
				<b-th></b-th>
				<b-th stacked-heading="Picking Supply For Production Detail">
					<v-select id="input-posting-supply-detail-for-production-picking-supply-for-production-detail-table" append-to-body label="materialPart" :options="pickingSupplyForProductionDetails" :value="filterPostingSupplyDetailForProduction.pickingSupplyForProductionDetailId" :reduce="item => item.id" v-model="filterPostingSupplyDetailForProduction.pickingSupplyForProductionDetailId" @search="getPickingSupplyForProductionDetails" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select id="input-posting-supply-detail-for-production-part-table" append-to-body label="partNumber" :options="parts" :value="filterPostingSupplyDetailForProduction.partId" :reduce="item => item.id" v-model="filterPostingSupplyDetailForProduction.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Material Part">
					<v-select id="input-posting-supply-detail-for-production-material-part-table" append-to-body label="partNumber" :options="parts" :value="filterPostingSupplyDetailForProduction.materialPartId" :reduce="item => item.id" v-model="filterPostingSupplyDetailForProduction.materialPartId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Supply">
					<b-form-input id="input-posting-supply-detail-for-production-qty-supply-table" v-model="filterPostingSupplyDetailForProduction.qtySupply" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Pic Picking">
					<v-select id="input-posting-supply-detail-for-production-pic-picking-table" append-to-body label="firstName" :options="userInfos" :value="filterPostingSupplyDetailForProduction.picPickingId" :reduce="item => item.id" v-model="filterPostingSupplyDetailForProduction.picPickingId" @search="getUserInfos" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="PicPenerima">
					<v-select id="input-posting-supply-detail-for-production-pic-penerima-table" append-to-body label="firstName" :options="userInfos" :value="filterPostingSupplyDetailForProduction.picPenerimaId" :reduce="item => item.id" v-model="filterPostingSupplyDetailForProduction.picPenerimaId" @search="getUserInfos" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Line">
					<v-select id="input-posting-supply-detail-for-production-line-table" append-to-body label="code" :options="lines" :value="filterPostingSupplyDetailForProduction.lineId" :reduce="item => item.id" v-model="filterPostingSupplyDetailForProduction.lineId" @search="getLines" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="PostingDate">
					<app-input-timepicker-range id="fieldset-posting-supply-detail-for-production-posting-date-row" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="PostingDate" size="sm" :modelFrom.sync="filterPostingSupplyDetailForProduction.postingDateFrom" :modelTo.sync="filterPostingSupplyDetailForProduction.postingDateTo" locale="en-GB" reset-button/>
				</b-th>
				<b-th stacked-heading="Area">
					<v-select id="input-posting-supply-detail-for-production-area-table" append-to-body label="code" :options="areas" :value="filterPostingSupplyDetailForProduction.areaId" :reduce="item => item.id" v-model="filterPostingSupplyDetailForProduction.areaId" @search="getAreas" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Rack">
					<v-select id="input-posting-supply-detail-for-production-rack-table" append-to-body label="code" :options="racks" :value="filterPostingSupplyDetailForProduction.rackId" :reduce="item => item.id" v-model="filterPostingSupplyDetailForProduction.rackId" @search="getRacks" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Document Status">
					<v-select id="input-posting-supply-detail-for-production-document-status-table" append-to-body label="name" :options="documentStatuss" :value="filterPostingSupplyDetailForProduction.documentStatusId" :reduce="item => item.id" v-model="filterPostingSupplyDetailForProduction.documentStatusId" @search="getDocumentStatuss" :filterable ="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( postingSupplyDetailForProductionPageSize * (currentPostingSupplyDetailForProductionPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(pickingSupplyForProductionDetail)="row">
				<app-input-combobox-autocomplete :options="pickingSupplyForProductionDetails" optionsLabel="materialPart" optionsKey="id" :id="'input-posting-supply-detail-for-production-picking-supply-for-production-detail-' + row.index" label-cols-lg="12" label="Picking Supply For Production Detail" size="sm" :model.sync="row.item.pickingSupplyForProductionDetailId"  @change="saveInputPostingSupplyDetailForProduction(row.item)" :selected="row.item.pickingSupplyForProductionDetail != null ? row.item.pickingSupplyForProductionDetail.materialPart : ''"  @input="getPickingSupplyForProductionDetails" :loading="isPickingSupplyForProductionDetailComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-posting-supply-detail-for-production-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputPostingSupplyDetailForProduction(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(materialPart)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-posting-supply-detail-for-production-material-part-' + row.index" label-cols-lg="12" label="Material Part" size="sm" :model.sync="row.item.materialPartId"  @change="saveInputPostingSupplyDetailForProduction(row.item)" :selected="row.item.materialPart != null ? row.item.materialPart.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(qtySupply)="row">
				<app-input-textbox :id="'input-posting-supply-detail-for-production-qty-supply-' + row.index" label-cols-lg="12" label="Qty Supply" size="sm" :model.sync="row.item.qtySupply"   @change="saveInputPostingSupplyDetailForProduction(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(picPicking)="row">
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-posting-supply-detail-for-production-pic-picking-' + row.index" label-cols-lg="12" label="Pic Picking" size="sm" :model.sync="row.item.picPickingId"  @change="saveInputPostingSupplyDetailForProduction(row.item)" :selected="row.item.picPicking != null ? row.item.picPicking.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(picPenerima)="row">
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-posting-supply-detail-for-production-pic-penerima-' + row.index" label-cols-lg="12" label="PicPenerima" size="sm" :model.sync="row.item.picPenerimaId"  @change="saveInputPostingSupplyDetailForProduction(row.item)" :selected="row.item.picPenerima != null ? row.item.picPenerima.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(line)="row">
				<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" :id="'input-posting-supply-detail-for-production-line-' + row.index" label-cols-lg="12" label="Line" size="sm" :model.sync="row.item.lineId"  @change="saveInputPostingSupplyDetailForProduction(row.item)" :selected="row.item.line != null ? row.item.line.code : ''"  @input="getLines" :loading="isLineComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(postingDate)="row">
				<app-input-timepicker :id="'input-posting-supply-detail-for-production-posting-date-' + row.index" label-cols-lg="12" label="PostingDate" size="sm" :model.sync="row.item.postingDate"   @change="saveInputPostingSupplyDetailForProduction(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"   :nolabel="true" />
			</template>
			<template v-slot:cell(area)="row">
				<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" :id="'input-posting-supply-detail-for-production-area-' + row.index" label-cols-lg="12" label="Area" size="sm" :model.sync="row.item.areaId"  @change="saveInputPostingSupplyDetailForProduction(row.item)" :selected="row.item.area != null ? row.item.area.code : ''"  @input="getAreas" :loading="isAreaComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(rack)="row">
				<app-input-combobox-autocomplete :options="racks" optionsLabel="code" optionsKey="id" :id="'input-posting-supply-detail-for-production-rack-' + row.index" label-cols-lg="12" label="Rack" size="sm" :model.sync="row.item.rackId"  @change="saveInputPostingSupplyDetailForProduction(row.item)" :selected="row.item.rack != null ? row.item.rack.code : ''"  @input="getRacks" :loading="isRackComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(documentStatus)="row">
				<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" :id="'input-posting-supply-detail-for-production-document-status-' + row.index" label-cols-lg="12" label="Document Status" size="sm" :model.sync="row.item.documentStatusId"  @change="saveInputPostingSupplyDetailForProduction(row.item)" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''"  @input="getDocumentStatuss" :loading="isDocumentStatusComboLoading"    :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<PostingSupplyDetailForProductionInput 
					:model="modelPostingSupplyDetailForProduction"
					:openPopup="isShowPopupPostingSupplyDetailForProduction"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPostingSupplyDetailForProduction"/>
			</template>
			<template v-slot:upload-detail>
					<PostingSupplyDetailForProductionUpload
					:openPopup="isShowPopupUploadPostingSupplyDetailForProduction"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPostingSupplyDetailForProduction"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPostingSupplyDetailForProductionPage"
				:total-rows="totalPostingSupplyDetailForProductionRow"
				:per-page="postingSupplyDetailForProductionPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>
		<app-table-input 
			title = "PostingSupplyCase"
			:bordered="true" :items="postingSupplyCases" 
			:fields="fieldsPostingSupplyCase" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByPostingSupplyCase" 
			:sort-desc.sync="sortDescPostingSupplyCase" small responsive	
			@editButtonMethod="editRowDataPostingSupplyCase"	
			@deleteButtonMethod="deleteRowDataPostingSupplyCase"	
			@showPopupAddMethod="addDataPostingSupplyCase()"	
			@showPopupUploadMethod="showPopupUploadPostingSupplyCase()"
			@downloadMethod="downloadPostingSupplyCase()"
			@addFromClipboardMethod="addFromClipboardPostingSupplyCase()"
			@replaceFromClipboardMethod="replaceFromClipboardPostingSupplyCase()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadPostingSupplyCase"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPostingSupplyCaseFilter = !isShowPostingSupplyCaseFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowPostingSupplyCaseFilter">
				<b-th></b-th>
				<b-th stacked-heading="Posting Supply Detail For Production">
					<v-select id="input-posting-supply-case-posting-supply-detail-for-production-table" append-to-body label="pickingSupplyForProductionDetail" :options="postingSupplyDetailForProductions" :value="filterPostingSupplyCase.postingSupplyDetailForProductionId" :reduce="item => item.id" v-model="filterPostingSupplyCase.postingSupplyDetailForProductionId" @search="getPostingSupplyDetailForProductions" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Picking Supply Detail For Production">
					<v-select id="input-posting-supply-case-picking-supply-detail-for-production-table" append-to-body label="materialPart" :options="pickingSupplyForProductionDetails" :value="filterPostingSupplyCase.pickingSupplyDetailForProductionId" :reduce="item => item.id" v-model="filterPostingSupplyCase.pickingSupplyDetailForProductionId" @search="getPickingSupplyForProductionDetails" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Control Card">
					<v-select id="input-posting-supply-case-control-card-table" append-to-body label="controlCardNumber" :options="controlCards" :value="filterPostingSupplyCase.controlCardId" :reduce="item => item.id" v-model="filterPostingSupplyCase.controlCardId" @search="getControlCards" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select id="input-posting-supply-case-part-table" append-to-body label="partNumber" :options="parts" :value="filterPostingSupplyCase.partId" :reduce="item => item.id" v-model="filterPostingSupplyCase.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty">
					<b-form-input id="input-posting-supply-case-qty-table" v-model="filterPostingSupplyCase.qty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Area">
					<v-select id="input-posting-supply-case-area-table" append-to-body label="code" :options="areas" :value="filterPostingSupplyCase.areaId" :reduce="item => item.id" v-model="filterPostingSupplyCase.areaId" @search="getAreas" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Rack">
					<v-select id="input-posting-supply-case-rack-table" append-to-body label="code" :options="racks" :value="filterPostingSupplyCase.rackId" :reduce="item => item.id" v-model="filterPostingSupplyCase.rackId" @search="getRacks" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Document Status">
					<v-select id="input-posting-supply-case-document-status-table" append-to-body label="name" :options="documentStatuss" :value="filterPostingSupplyCase.documentStatusId" :reduce="item => item.id" v-model="filterPostingSupplyCase.documentStatusId" @search="getDocumentStatuss" :filterable ="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( postingSupplyCasePageSize * (currentPostingSupplyCasePage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(postingSupplyDetailForProduction)="row">
				<app-input-combobox-autocomplete :options="postingSupplyDetailForProductions" optionsLabel="pickingSupplyForProductionDetail" optionsKey="id" :id="'input-posting-supply-case-posting-supply-detail-for-production-' + row.index" label-cols-lg="12" label="Posting Supply Detail For Production" size="sm" :model.sync="row.item.postingSupplyDetailForProductionId"  @change="saveInputPostingSupplyCase(row.item)" :selected="row.item.postingSupplyDetailForProduction != null ? row.item.postingSupplyDetailForProduction.pickingSupplyForProductionDetail : ''"  @input="getPostingSupplyDetailForProductions" :loading="isPostingSupplyDetailForProductionComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(pickingSupplyDetailForProduction)="row">
				<app-input-combobox-autocomplete :options="pickingSupplyForProductionDetails" optionsLabel="materialPart" optionsKey="id" :id="'input-posting-supply-case-picking-supply-detail-for-production-' + row.index" label-cols-lg="12" label="Picking Supply Detail For Production" size="sm" :model.sync="row.item.pickingSupplyDetailForProductionId"  @change="saveInputPostingSupplyCase(row.item)" :selected="row.item.pickingSupplyDetailForProduction != null ? row.item.pickingSupplyDetailForProduction.materialPart : ''"  @input="getPickingSupplyForProductionDetails" :loading="isPickingSupplyForProductionDetailComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-posting-supply-case-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputPostingSupplyCase(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-posting-supply-case-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputPostingSupplyCase(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(qty)="row">
				<app-input-textbox :id="'input-posting-supply-case-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   @change="saveInputPostingSupplyCase(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(area)="row">
				<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" :id="'input-posting-supply-case-area-' + row.index" label-cols-lg="12" label="Area" size="sm" :model.sync="row.item.areaId"  @change="saveInputPostingSupplyCase(row.item)" :selected="row.item.area != null ? row.item.area.code : ''"  @input="getAreas" :loading="isAreaComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(rack)="row">
				<app-input-combobox-autocomplete :options="racks" optionsLabel="code" optionsKey="id" :id="'input-posting-supply-case-rack-' + row.index" label-cols-lg="12" label="Rack" size="sm" :model.sync="row.item.rackId"  @change="saveInputPostingSupplyCase(row.item)" :selected="row.item.rack != null ? row.item.rack.code : ''"  @input="getRacks" :loading="isRackComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(documentStatus)="row">
				<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" :id="'input-posting-supply-case-document-status-' + row.index" label-cols-lg="12" label="Document Status" size="sm" :model.sync="row.item.documentStatusId"  @change="saveInputPostingSupplyCase(row.item)" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''"  @input="getDocumentStatuss" :loading="isDocumentStatusComboLoading"    :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<PostingSupplyCaseInput 
					:model="modelPostingSupplyCase"
					:openPopup="isShowPopupPostingSupplyCase"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPostingSupplyCase"/>
			</template>
			<template v-slot:upload-detail>
					<PostingSupplyCaseUpload
					:openPopup="isShowPopupUploadPostingSupplyCase"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPostingSupplyCase"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPostingSupplyCasePage"
				:total-rows="totalPostingSupplyCaseRow"
				:per-page="postingSupplyCasePageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PostingSupplyForProduction from '@/models/PostingSupplyForProduction/PostingSupplyForProduction';
import PostingSupplyForProductionList from '@/models/PostingSupplyForProduction/PostingSupplyForProductionList';
import PostingSupplyForProductionFilter from '@/filters/PostingSupplyForProduction/PostingSupplyForProductionFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PickingSupplyForProduction from '@/models/PickingSupplyForProduction/PickingSupplyForProduction';
import PickingSupplyForProductionFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionFilter';
import WorkOrderSupply from '@/models/WorkOrderSupply/WorkOrderSupply';
import WorkOrderSupplyFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyFilter';
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import PostingSupplyDetailForProduction from '@/models/PostingSupplyForProduction/PostingSupplyDetailForProduction';
import PostingSupplyDetailForProductionFilter from '@/filters/PostingSupplyForProduction/PostingSupplyDetailForProductionFilter';
import PostingSupplyCase from '@/models/PostingSupplyForProduction/PostingSupplyCase';
import PostingSupplyCaseFilter from '@/filters/PostingSupplyForProduction/PostingSupplyCaseFilter';
import PickingSupplyForProductionDetail from '@/models/PickingSupplyForProduction/PickingSupplyForProductionDetail';
import PickingSupplyForProductionDetailFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputTimepicker from '@/components/AppInputTimepicker';
import AppInputTimepickerRange from '@/components/AppInputTimepickerRange';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import Rack from '@/models/Rack/Rack';
import RackFilter from '@/filters/Rack/RackFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PostingSupplyDetailForProductionInput from '@/views/PostingSupplyForProduction/PostingSupplyDetailForProductionInput';
import PostingSupplyDetailForProductionUpload from '@/views/PostingSupplyForProduction/PostingSupplyDetailForProductionUpload';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PostingSupplyCaseInput from '@/views/PostingSupplyForProduction/PostingSupplyCaseInput';
import PostingSupplyCaseUpload from '@/views/PostingSupplyForProduction/PostingSupplyCaseUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		AppInputTimepicker,
		AppInputTimepickerRange,
		PostingSupplyDetailForProductionInput,PostingSupplyDetailForProductionUpload,
		PostingSupplyCaseInput,PostingSupplyCaseUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsPostingSupplyDetailForProduction: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"pickingSupplyForProductionDetail": { "class" : "th-picking-supply-for-production-detail first-child", "label" : "Picking Supply For Production Detail", key: 'pickingSupplyForProductionDetail', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part', sortable: false}}, 
				{"materialPart": { "class" : "th-material-part last-child", "label" : "Material Part", key: 'materialPart', sortable: false}}, 
				{"qtySupply": { "class" : "th-qty-supply d-stack-none", "label" : "Qty Supply", key: 'qtySupply', sortable: false}}, 
				{"picPicking": { "class" : "th-pic-picking d-stack-none", "label" : "Pic Picking", key: 'picPicking', sortable: false}}, 
				{"picPenerima": { "class" : "th-pic-penerima d-stack-none", "label" : "PicPenerima", key: 'picPenerima', sortable: false}}, 
				{"line": { "class" : "th-line d-stack-none", "label" : "Line", key: 'line', sortable: false}}, 
				{"postingDate": { "class" : "th-posting-date d-stack-none", "label" : "PostingDate", key: 'postingDate', sortable: false}}, 
				{"area": { "class" : "th-area d-stack-none", "label" : "Area", key: 'area', sortable: false}}, 
				{"rack": { "class" : "th-rack d-stack-none", "label" : "Rack", key: 'rack', sortable: false}}, 
				{"documentStatus": { "class" : "th-document-status d-stack-none", "label" : "Document Status", key: 'documentStatus', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsPostingSupplyCase: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"postingSupplyDetailForProduction": { "class" : "th-posting-supply-detail-for-production first-child", "label" : "Posting Supply Detail For Production", key: 'postingSupplyDetailForProduction', sortable: false}}, 
				{"pickingSupplyDetailForProduction": { "class" : "th-picking-supply-detail-for-production", "label" : "Picking Supply Detail For Production", key: 'pickingSupplyDetailForProduction', sortable: false}}, 
				{"controlCard": { "class" : "th-control-card last-child", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"part": { "class" : "th-part d-stack-none", "label" : "Part", key: 'part', sortable: false}}, 
				{"qty": { "class" : "th-qty d-stack-none", "label" : "Qty", key: 'qty', sortable: false}}, 
				{"area": { "class" : "th-area d-stack-none", "label" : "Area", key: 'area', sortable: false}}, 
				{"rack": { "class" : "th-rack d-stack-none", "label" : "Rack", key: 'rack', sortable: false}}, 
				{"documentStatus": { "class" : "th-document-status d-stack-none", "label" : "Document Status", key: 'documentStatus', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPostingSupplyDetailForProduction : {},
			isShowPopupPostingSupplyDetailForProduction : false,
			isShowPopupUploadPostingSupplyDetailForProduction : false,
			modelPostingSupplyCase : {},
			isShowPopupPostingSupplyCase : false,
			isShowPopupUploadPostingSupplyCase : false,
			filterPostingSupplyForProduction : null,
			currentPostingSupplyForProductionPage : 1,
			postingSupplyForProductionPageSize: 10,
			sortByPostingSupplyForProduction: '',
			sortDescPostingSupplyForProduction: '',
			filterPostingSupplyDetailForProduction : null,
			currentPostingSupplyDetailForProductionPage : 1,
			postingSupplyDetailForProductionPageSize: 10,
			sortByPostingSupplyDetailForProduction: '',
			sortDescPostingSupplyDetailForProduction: '',
			sortingByPostingSupplyDetailForProduction: [],
			postingSupplyDetailForProductions : [],
			postingSupplyDetailForProductionId : '',
			totalPostingSupplyDetailForProductionRow : 0,
			isShowPostingSupplyDetailForProductionFilter: false,
			isDownloadPostingSupplyDetailForProduction: false,
			filterPostingSupplyCase : null,
			currentPostingSupplyCasePage : 1,
			postingSupplyCasePageSize: 10,
			sortByPostingSupplyCase: '',
			sortDescPostingSupplyCase: '',
			sortingByPostingSupplyCase: [],
			postingSupplyCases : [],
			postingSupplyCaseId : '',
			totalPostingSupplyCaseRow : 0,
			isShowPostingSupplyCaseFilter: false,
			isDownloadPostingSupplyCase: false,
			pickingSupplyForProductionDetails: [],
			parts: [],
			userInfos: [],
			lines: [],
			areas: [],
			racks: [],
			documentStatuss: [],
			postingSupplyDetailForProductions: [],
			controlCards: [],
			pickingSupplyForProductions: [],
			pickingSupplyForProductions: [],
			isPickingSupplyForProductionComboLoading: false,
			workOrderSupplys: [],
			workOrderSupplys: [],
			isWorkOrderSupplyComboLoading: false,
			workOrderProcesss: [],
			workOrderProcesss: [],
			isWorkOrderProcessComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPickingSupplyForProductionComboLoading: false,
			isWorkOrderSupplyComboLoading: false,
			isWorkOrderProcessComboLoading: false,
			isLineComboLoading: false,
			isDocumentStatusComboLoading: false,
			isPostingSupplyForProductionComboLoading: false,
			isPickingSupplyForProductionDetailComboLoading: false,
			isPartComboLoading: false,
			isUserInfoComboLoading: false,
			isAreaComboLoading: false,
			isRackComboLoading: false,
			isPostingSupplyDetailForProductionComboLoading: false,
			isControlCardComboLoading: false,
		}
	},
	methods : {
		getPostingSupplyForProduction : async function(id) {
			this.isBusy = true;
			PostingSupplyForProduction.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPostingSupplyForProduction = true;
			this.filterPostingSupplyForProduction.id = this.modelId;
			PostingSupplyForProduction.downloadDataDetail(this, this.filterPostingSupplyForProduction).then(result => {
				this.isDownloadPostingSupplyForProduction = false;
			}).catch(error => { this.isDownloadPostingSupplyForProduction = false; })
		},
		getPostingSupplyDetailForProductions : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPostingSupplyDetailForProduction);
			if (this.modelId == null) return;
			filter.postingSupplyForProductionId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByPostingSupplyDetailForProduction != null) {
				this.sortingByPostingSupplyDetailForProduction[this.sortByPostingSupplyDetailForProduction] = this.sortDescPostingSupplyDetailForProduction;
			}
			let currentPage = (this.currentPostingSupplyDetailForProductionPage - 1);
			if (isAddRow) {
				let totalData = this.totalPostingSupplyDetailForProductionRow + 1;
				let page = Math.ceil(totalData/this.postingSupplyDetailForProductionPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.postingSupplyDetailForProductionPageSize = 0;
			// disable paging end
			PostingSupplyDetailForProduction.getList(this, filter, this.sortingByPostingSupplyDetailForProduction, currentPage , this.postingSupplyDetailForProductionPageSize).then(result => {
				this.currentPostingSupplyDetailForProductionPage = currentPage + 1;
				this.postingSupplyDetailForProductions = result.data;
				this.totalPostingSupplyDetailForProductionRow = result.dataCount;
			}).catch(error => {});
		},
		getPostingSupplyCases : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPostingSupplyCase);
			if (this.modelId == null) return;
			filter.postingSupplyForProductionId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByPostingSupplyCase != null) {
				this.sortingByPostingSupplyCase[this.sortByPostingSupplyCase] = this.sortDescPostingSupplyCase;
			}
			let currentPage = (this.currentPostingSupplyCasePage - 1);
			if (isAddRow) {
				let totalData = this.totalPostingSupplyCaseRow + 1;
				let page = Math.ceil(totalData/this.postingSupplyCasePageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.postingSupplyCasePageSize = 0;
			// disable paging end
			PostingSupplyCase.getList(this, filter, this.sortingByPostingSupplyCase, currentPage , this.postingSupplyCasePageSize).then(result => {
				this.currentPostingSupplyCasePage = currentPage + 1;
				this.postingSupplyCases = result.data;
				this.totalPostingSupplyCaseRow = result.dataCount;
			}).catch(error => {});
		},
		getPostingSupplyForProductions : async function(input) {
			let filter = new PostingSupplyForProductionFilter();
			if (input != undefined) {
				filter.PickingSupplyForProduction = input;
			}
			this.isPostingSupplyForProductionComboLoading = true;
			PostingSupplyForProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.postingSupplyForProductions = result.data
				}
				this.isPostingSupplyForProductionComboLoading = false;
			})
			.catch(error => {});
		},
		getPostingSupplyForProductions : async function(input) {
			let filter = new PostingSupplyForProductionFilter();
			if (input != undefined) {
				filter.pickingSupplyForProduction = input;
			}
			this.isPostingSupplyForProductionComboLoading = true;
			PostingSupplyForProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.postingSupplyForProductions = result.data
				}
				this.isPostingSupplyForProductionComboLoading = false;
			})
			.catch(error => {});
		},
		getPickingSupplyForProductionDetails : async function(input) {
			let filter = new PickingSupplyForProductionDetailFilter();
			if (input != undefined) {
				filter.materialPart = input;
			}
			this.isPickingSupplyForProductionDetailComboLoading = true;
			PickingSupplyForProductionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForProductionDetails = result.data
				}
				this.isPickingSupplyForProductionDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			this.isUserInfoComboLoading = true;
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isLineComboLoading = true;
			Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
				this.isLineComboLoading = false;
			})
			.catch(error => {});
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isAreaComboLoading = true;
			Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
				this.isAreaComboLoading = false;
			})
			.catch(error => {});
		},
		getRacks : async function(input) {
			let filter = new RackFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isRackComboLoading = true;
			Rack.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.racks = result.data
				}
				this.isRackComboLoading = false;
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isDocumentStatusComboLoading = true;
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
				this.isDocumentStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getPostingSupplyDetailForProductions : async function(input) {
			let filter = new PostingSupplyDetailForProductionFilter();
			if (input != undefined) {
				filter.pickingSupplyForProductionDetail = input;
			}
			this.isPostingSupplyDetailForProductionComboLoading = true;
			PostingSupplyDetailForProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.postingSupplyDetailForProductions = result.data
				}
				this.isPostingSupplyDetailForProductionComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getPickingSupplyForProductions : async function(input) {
			let filter = new PickingSupplyForProductionFilter();
			if (input != undefined) {
				filter.workOrderSupply = input;
			}
			PickingSupplyForProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForProductions = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPickingSupplyForProduction(item) {
			if(item == undefined || item == null) {
				this.model.pickingSupplyForProductionId = null;
				this.model.pickingSupplyForProduction = null;
			} else {
				this.model.pickingSupplyForProductionId = item.id;
				this.model.pickingSupplyForProduction = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderSupplys : async function(input) {
			let filter = new WorkOrderSupplyFilter();
			if (input != undefined) {
				filter.workOrderSupplyDate = input;
			}
			WorkOrderSupply.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderSupply(item) {
			if(item == undefined || item == null) {
				this.model.workOrderSupplyId = null;
				this.model.workOrderSupply = null;
			} else {
				this.model.workOrderSupplyId = item.id;
				this.model.workOrderSupply = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcess(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessId = null;
				this.model.workOrderProcess = null;
			} else {
				this.model.workOrderProcessId = item.id;
				this.model.workOrderProcess = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedLine(item) {
			if(item == undefined || item == null) {
				this.model.lineId = null;
				this.model.line = null;
			} else {
				this.model.lineId = item.id;
				this.model.line = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.postingSupplyForProductionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PostingSupplyForProduction.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'postingsupplyforproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PostingSupplyForProduction.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'postingsupplyforproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PostingSupplyForProduction.updateData(this, model, id)
					.catch((error) => {
						this.getPostingSupplyForProduction(id);
					});
				}
			});
		},
		onHidden() {
			this.getPostingSupplyForProductions();
		},
		addRowDataPostingSupplyDetailForProduction(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.postingSupplyForProductionId =  this.modelId;
					PostingSupplyDetailForProduction.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPostingSupplyDetailForProductions(true);
						this.isShowPopupPostingSupplyDetailForProduction = false;
					})
				} else {
					model.postingSupplyForProductionId =  this.modelId;
					PostingSupplyDetailForProduction.createDataDetail(this, model)
					.then(result => {
						this.getPostingSupplyDetailForProductions(true);
						this.isShowPopupPostingSupplyDetailForProduction = false;
					})
				}
			}
		},
		async editRowDataPostingSupplyDetailForProduction(id) {
			this.postingSupplyDetailForProductionId = id;
			this.isShowPopupPostingSupplyDetailForProduction = true; 
		},
		async deleteRowDataPostingSupplyDetailForProduction(id) {
			PostingSupplyDetailForProduction.deleteData(this, id).then(result => { this.getPostingSupplyDetailForProductions(); });
		},
		async resetDataPostingSupplyDetailForProduction() {
			this.postingSupplyDetailForProductionId = "";
			this.isShowPopupPostingSupplyDetailForProduction = true;
		},
		async addDataPostingSupplyDetailForProduction() {
			PostingSupplyDetailForProduction.createData(this, { postingSupplyForProductionId: this.modelId })
			.then(result => {
				this.getPostingSupplyDetailForProductions(true);
			})
		},
		async addFromClipboardPostingSupplyDetailForProduction() {
			let pickingSupplyForProductionDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					pickingSupplyForProductionDetails.push({ pickingSupplyForProductionDetail: item, postingSupplyForProductionId: this.modelId });
				});
				PostingSupplyDetailForProduction.addFromClipboard(this, pickingSupplyForProductionDetails).then(result => { this.getPostingSupplyDetailForProductions() });
			});
		},
		async replaceFromClipboardPostingSupplyDetailForProduction() {
			let pickingSupplyForProductionDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					pickingSupplyForProductionDetails.push({ pickingSupplyForProductionDetail: item, postingSupplyForProductionId: this.modelId });
				});
				PostingSupplyDetailForProduction.replaceFromClipboard(this, pickingSupplyForProductionDetails).then(result => { this.getPostingSupplyDetailForProductions() });
			});   
		},
		showPopupUploadPostingSupplyDetailForProduction() {
			if(this.postingSupplyDetailForProductions != null && this.postingSupplyDetailForProductions.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PostingSupplyDetailForProduction akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPostingSupplyDetailForProduction = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPostingSupplyDetailForProduction = true;
			}
		},
		uploadDataPostingSupplyDetailForProduction(modalEvent, newDatas) {
			this.isShowPopupUploadPostingSupplyDetailForProduction = false; 
		},
		downloadPostingSupplyDetailForProduction(modalEvent) {
			this.isDownloadPostingSupplyDetailForProduction = true;
			this.filterPostingSupplyDetailForProduction.postingSupplyForProductionId = this.modelId;
			PostingSupplyDetailForProduction.downloadDataDetail(this, this.filterPostingSupplyDetailForProduction).then(result => {
				this.isDownloadPostingSupplyDetailForProduction = false;
			}).catch(error => { this.isDownloadPostingSupplyDetailForProduction = false; })
		},
		saveInputPostingSupplyDetailForProduction(item) {
			if (this.postingSupplyForProductions != null && this.postingSupplyForProductions != undefined  && this.postingSupplyForProductions.length > 0) {
				item.postingSupplyForProduction = this.postingSupplyForProductions.find(q => q.id == item.postingSupplyForProductionId);
			}
			if (this.pickingSupplyForProductionDetails != null && this.pickingSupplyForProductionDetails != undefined  && this.pickingSupplyForProductionDetails.length > 0) {
				item.pickingSupplyForProductionDetail = this.pickingSupplyForProductionDetails.find(q => q.id == item.pickingSupplyForProductionDetailId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.userInfos != null && this.userInfos != undefined  && this.userInfos.length > 0) {
				item.picPicking = this.userInfos.find(q => q.id == item.picPickingUserName);
			}
			if (this.lines != null && this.lines != undefined  && this.lines.length > 0) {
				item.line = this.lines.find(q => q.id == item.lineId);
			}
			if (this.areas != null && this.areas != undefined  && this.areas.length > 0) {
				item.area = this.areas.find(q => q.id == item.areaId);
			}
			if (this.racks != null && this.racks != undefined  && this.racks.length > 0) {
				item.rack = this.racks.find(q => q.id == item.rackId);
			}
			if (this.documentStatuss != null && this.documentStatuss != undefined  && this.documentStatuss.length > 0) {
				item.documentStatus = this.documentStatuss.find(q => q.id == item.documentStatusId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PostingSupplyDetailForProduction.updateData(this, item, item.id);
				}
			});
		},
		addRowDataPostingSupplyCase(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.postingSupplyForProductionId =  this.modelId;
					PostingSupplyCase.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPostingSupplyCases(true);
						this.isShowPopupPostingSupplyCase = false;
					})
				} else {
					model.postingSupplyForProductionId =  this.modelId;
					PostingSupplyCase.createDataDetail(this, model)
					.then(result => {
						this.getPostingSupplyCases(true);
						this.isShowPopupPostingSupplyCase = false;
					})
				}
			}
		},
		async editRowDataPostingSupplyCase(id) {
			this.postingSupplyCaseId = id;
			this.isShowPopupPostingSupplyCase = true; 
		},
		async deleteRowDataPostingSupplyCase(id) {
			PostingSupplyCase.deleteData(this, id).then(result => { this.getPostingSupplyCases(); });
		},
		async resetDataPostingSupplyCase() {
			this.postingSupplyCaseId = "";
			this.isShowPopupPostingSupplyCase = true;
		},
		async addDataPostingSupplyCase() {
			PostingSupplyCase.createData(this, { postingSupplyForProductionId: this.modelId })
			.then(result => {
				this.getPostingSupplyCases(true);
			})
		},
		async addFromClipboardPostingSupplyCase() {
			let postingSupplyDetailForProductions = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					postingSupplyDetailForProductions.push({ postingSupplyDetailForProduction: item, postingSupplyForProductionId: this.modelId });
				});
				PostingSupplyCase.addFromClipboard(this, postingSupplyDetailForProductions).then(result => { this.getPostingSupplyCases() });
			});
		},
		async replaceFromClipboardPostingSupplyCase() {
			let postingSupplyDetailForProductions = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					postingSupplyDetailForProductions.push({ postingSupplyDetailForProduction: item, postingSupplyForProductionId: this.modelId });
				});
				PostingSupplyCase.replaceFromClipboard(this, postingSupplyDetailForProductions).then(result => { this.getPostingSupplyCases() });
			});   
		},
		showPopupUploadPostingSupplyCase() {
			if(this.postingSupplyCases != null && this.postingSupplyCases.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PostingSupplyCase akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPostingSupplyCase = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPostingSupplyCase = true;
			}
		},
		uploadDataPostingSupplyCase(modalEvent, newDatas) {
			this.isShowPopupUploadPostingSupplyCase = false; 
		},
		downloadPostingSupplyCase(modalEvent) {
			this.isDownloadPostingSupplyCase = true;
			this.filterPostingSupplyCase.postingSupplyForProductionId = this.modelId;
			PostingSupplyCase.downloadDataDetail(this, this.filterPostingSupplyCase).then(result => {
				this.isDownloadPostingSupplyCase = false;
			}).catch(error => { this.isDownloadPostingSupplyCase = false; })
		},
		saveInputPostingSupplyCase(item) {
			if (this.postingSupplyDetailForProductions != null && this.postingSupplyDetailForProductions != undefined  && this.postingSupplyDetailForProductions.length > 0) {
				item.postingSupplyDetailForProduction = this.postingSupplyDetailForProductions.find(q => q.id == item.postingSupplyDetailForProductionId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PostingSupplyCase.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPostingSupplyDetailForProduction = false; 
			this.isShowPopupPostingSupplyDetailForProduction = false; 
			if (modalType == 'PostingSupplyDetailForProduction') {
				this.getPostingSupplyDetailForProductions();
			}
			this.isShowPopupUploadPostingSupplyCase = false; 
			this.isShowPopupPostingSupplyCase = false; 
			if (modalType == 'PostingSupplyCase') {
				this.getPostingSupplyCases();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowPostingSupplyDetailForProductionFilter = true;
				//this.isShowPostingSupplyCaseFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPostingSupplyForProduction = new PostingSupplyForProductionFilter();
		this.filterPostingSupplyDetailForProduction = new PostingSupplyDetailForProductionFilter();
		this.filterPostingSupplyCase = new PostingSupplyCaseFilter();
		//this.getPostingSupplyForProductions();
		//this.getPickingSupplyForProductionDetails();
		//this.getParts();
		//this.getUserInfos();
		//this.getLines();
		//this.getAreas();
		//this.getRacks();
		//this.getDocumentStatuss();
		//this.getPostingSupplyDetailForProductions();
		//this.getControlCards();
		//this.getPickingSupplyForProductions();
		//this.getWorkOrderSupplys();
		//this.getWorkOrderProcesss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPostingSupplyForProduction(id);
			} else {
				this.modelId = id;
				this.getPostingSupplyForProduction(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByPostingSupplyDetailForProduction : {
			handler: function() {
				this.getPostingSupplyDetailForProductions();
			}
		},
		sortDescPostingSupplyDetailForProduction: {
			handler: function() {
				this.getPostingSupplyDetailForProductions();
			}
		},
		currentPostingSupplyDetailForProductionPage: {
			handler: function() {
				this.getPostingSupplyDetailForProductions();
			}
		},
		postingSupplyDetailForProductionPageSize : {
			handler: function() {
				this.getPostingSupplyDetailForProductions();
			}
		},
		filterPostingSupplyDetailForProduction: {
			handler: function() {
				this.getPostingSupplyDetailForProductions();
			},
			deep: true,
		},
		sortByPostingSupplyCase : {
			handler: function() {
				this.getPostingSupplyCases();
			}
		},
		sortDescPostingSupplyCase: {
			handler: function() {
				this.getPostingSupplyCases();
			}
		},
		currentPostingSupplyCasePage: {
			handler: function() {
				this.getPostingSupplyCases();
			}
		},
		postingSupplyCasePageSize : {
			handler: function() {
				this.getPostingSupplyCases();
			}
		},
		filterPostingSupplyCase: {
			handler: function() {
				this.getPostingSupplyCases();
			},
			deep: true,
		},
	},
}
</script>
